var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.375 19C2.375 18.685 2.50011 18.383 2.72281 18.1603C2.94551 17.9376 3.24756 17.8125 3.5625 17.8125H31.5709L24.0968 10.3407C23.8738 10.1177 23.7485 9.81532 23.7485 9.49997C23.7485 9.18463 23.8738 8.8822 24.0968 8.65922C24.3197 8.43624 24.6222 8.31097 24.9375 8.31097C25.2528 8.31097 25.5553 8.43624 25.7783 8.65922L35.2783 18.1592C35.3888 18.2695 35.4766 18.4006 35.5364 18.5448C35.5963 18.6891 35.6271 18.8438 35.6271 19C35.6271 19.1562 35.5963 19.3108 35.5364 19.4551C35.4766 19.5994 35.3888 19.7304 35.2783 19.8407L25.7783 29.3407C25.5553 29.5637 25.2528 29.689 24.9375 29.689C24.6222 29.689 24.3197 29.5637 24.0968 29.3407C23.8738 29.1177 23.7485 28.8153 23.7485 28.5C23.7485 28.1846 23.8738 27.8822 24.0968 27.6592L31.5709 20.1875H3.5625C3.24756 20.1875 2.94551 20.0624 2.72281 19.8397C2.50011 19.617 2.375 19.3149 2.375 19Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.431dfe2d2a3bcdcf48faae0fe41f2b22.svg";
export { ForwardRef as ReactComponent };